import { render, staticRenderFns } from "./GalleryHome.vue?vue&type=template&id=21f0ab2b&"
import script from "./GalleryHome.vue?vue&type=script&lang=js&"
export * from "./GalleryHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports